import React from "react"
import Email from "../images/components/email.svg"
import Facebook from "../images/components/facebook.svg"
import Instagram from "../images/components/instagram.svg"
import Twitter from "../images/components/twitter.svg"
import Video from "../images/components/video.svg"
import Youtube from "../images/components/youtube.svg"

const IconButton = ({ icon, link }) => {
  let Icon

  if (icon === "email") {
    Icon = Email
  } else if (icon === "facebook") {
    Icon = Facebook
  } else if (icon === "instagram") {
    Icon = Instagram
  } else if (icon === "twitter") {
    Icon = Twitter
  } else if (icon === "vimeo") {
    Icon = Video
  } else if (icon === "youtube") {
    Icon = Youtube
  }

  return Icon ? (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={`iconButton iconButton--${icon}`}
    >
      <Icon />
    </a>
  ) : null
}

export default IconButton
